module.exports = __webpack_public_path__ + "img/logo-oreal.f2f11960.jpg";